import { HttpClient } from '@angular/common/http';
import { Component, inject } from '@angular/core';
import { CustomModalService } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-excle-template-info',
  templateUrl: './excle-template-info.component.html',
  styleUrls: ['./excle-template-info.component.scss'],
})
export class ExcleTemplateInfoComponent {
  constructor(private cookieService: CookieService) {}

  modal = inject(CustomModalService);
  http = inject(HttpClient);
  onClose(): void {
    this.modal.close();
  }

  downloadTemplate(): void {
    const filePath =
      Number(this.cookieService.get('organizationId')) == 237
        ? 'assets/documents/ProjectImportTemplateQuadpack.xlsm'
        : 'assets/documents/ProjectImportTemplate.xlsm';
    this.http.get(filePath, { responseType: 'blob' }).subscribe({
      next: (data: Blob | MediaSource) => {
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'ProjectImportTemplate.xlsm';
        link.click();
        window.URL.revokeObjectURL(url);
        this.modal.close();
      },
      error: error => {
        console.error('Error downloading template:', error);
        this.modal.close();
      },
    });
  }
}
